import { useEffect, useState } from 'react'

import { getCookie } from '@/utils/general/cookie'
import { isServer } from '@/utils/general'
import { fetchWorkplusIsCfwUser, parseWorkplusUserIdFromUseridCookie } from '@/utils/cfw/workplusUserState'

export function useWorkplusCfwTrialAccount(): boolean {
  const [isCfwTrial, setIsCfwTrial] = useState(false)

  useEffect(() => {
    if (isServer()) return
    const userId = parseWorkplusUserIdFromUseridCookie(getCookie('userid') || '')
    if (!userId) {
      setIsCfwTrial(false)
      return
    }
    let cancelled = false
    void (async () => {
      try {
        const ok = await fetchWorkplusIsCfwUser(userId)
        if (!cancelled) setIsCfwTrial(ok)
      } catch {
        if (!cancelled) setIsCfwTrial(false)
      }
    })
    return () => {
      cancelled = true
    }
  }, [])

  return isCfwTrial
}
